/**
 * Flow Mode Persistence
 * Stores the verification flow mode so SPA navigation doesn't drop it.
 */

export type FlowMode = 'new-tab' | 'redirect';

const STORAGE_KEY = 'sp_flow_mode';

export function storeFlowMode(mode: string | null): void {
  if (mode !== 'new-tab' && mode !== 'redirect') {
    return;
  }
  try {
    sessionStorage.setItem(STORAGE_KEY, mode);
  } catch {
    // Ignore storage errors (private mode, etc.)
  }
}

export function getStoredFlowMode(): FlowMode | null {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (raw === 'new-tab' || raw === 'redirect') {
      return raw;
    }
    return null;
  } catch {
    return null;
  }
}
